import { inject, InjectionToken } from "@angular/core";
import { Route } from "@angular/router";
import { DynamicTabsService } from "@app/shared-core/general/dynamic-tabs/dynamic-tabs.service";
import { APP_ROUTE_PATHS } from "@app/app-route-paths";
import { ExpirationSettingsRoutePaths } from "@app/applications/settings/domains/expiration-settings/expiration-settings-route-path";
import { QuotationExpirationSettingsRoutePaths } from "../quotation-expiration-settings-route-path";
import { quotationExpirationSettingsRoutes } from "../quotation-expiration-settings.routes";
import { PERMISSION_CONSTANTS } from "@app/shared/auth/constants/permissions.constant";

export const quotationExpirationSettingsDynamicRoutesConfig: Route[] = [
  {
    path: ExpirationSettingsRoutePaths.EXPIRATION_SETTINGS,
    children: [{ path: "", children: [...quotationExpirationSettingsRoutes] }],
  },
];

export const ADD_QUOTATION_EXPIRATION_SETTINGS_TABS = new InjectionToken("ADD_QUOTATION_EXPIRATION_SETTINGS_ROUTES", {
  providedIn: "root",
  factory: () => {
    inject(DynamicTabsService).addTabs(
      ExpirationSettingsRoutePaths.EXPIRATION_SETTINGS,
      [
        {
          route: QuotationExpirationSettingsRoutePaths.ROOT,
          label: "QUOTATION_EXPIRATION_SETTINGS.TITLES.QUOTATION_EXPIRATION_SETTINGS",
          permissions: [PERMISSION_CONSTANTS.QUOTATION_EXPIRATION_SETTINGS.VIEW, PERMISSION_CONSTANTS.QUOTATION_EXPIRATION_SETTINGS.SET],
        },
      ],
      { parentRoutePath: APP_ROUTE_PATHS.SETTINGS, routes: quotationExpirationSettingsDynamicRoutesConfig }
    );
  },
});
